import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-core',
    templateUrl: './core.component.html',
    styleUrls: ['./core.component.scss'],
    standalone: false
})
export class CoreComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
